<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="practiceId" :confirm="true"
                    :title="practice.title" route-back="PracticeIndex"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm card-scrollable">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.fileRobustagno.invalidFeedback"
                    class="medium-label mb-4">
                    <div class="d-flex">
                      <label for="fileRobustagno-input">
                        {{ $t('FILE') }}
                      </label>
                    </div>
                    <b-form-file
                      id="fileRobustagno-input"
                      v-model="form.fileRobustagno.value"
                      :drop-placeholder="$t('drop-placeholder')"
                      :placeholder="form.fileRobustagno.value"
                      :state="form.fileRobustagno.state"
                      tabindex="4"
                      accept=".png, .jpeg, .jpg,.pdf">
                    </b-form-file>
                  </b-form-group>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <b-button tabindex="10" type="submit" variant="primary">{{$t('Validate')+' '+$t('l.e')+' '+$t('practice')}}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import AutocompleteField from "../../components/b122/editFields/AutocompleteField";

export default {

  name: 'PracticeEdit',

  components: {
    BackArrow,
    DateField,
    AutocompleteField
  },

  data() {
    return {
      practiceId: this.$route.params.practiceId,
      askConfirm: false,
      form: {
        fileRobustagno:
          {
            state: null,
            invalidFeedback: null,
            value: null,
          },
      },
      practice:{},
    }
  },

  mounted() {
    this.fetchData()
  },


  methods: {

    async fetchData() {
      if(this.practiceId){
        await this.fetchPractice()
      }
    },

    async fetchPractice(){
      api
        .get('/practice/'+this.practiceId)
        .then(response => {
          this.practice = response.data
          console.log(this.practice)
          this.setInitialValues()
        })
    },

    setInitialValues() {
      if (this.practice != null) {
        if(this.practice.fileRobustagno&&this.practice.fileRobustagno.fileName){
          this.form.fileRobustagno.value=this.practice.fileRobustagno.fileName
        }
      }
    },
    async onSubmit() {

      if(!this.practiceId){
        return
      }

      let data = new FormData()
      data.append('fileRobustagno', this.form.fileRobustagno.value)

      await api({
        method: 'POST',
        url: '/practice/' + this.practiceId,
        data: data
      })
        .then((response) => {
          this.$router.push({
              name:"PracticeIndex"
            },
            () => {
              this.$nextTick(() => {
                this.successToast(this.practice.title)
              })
            })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name:"PracticeIndex"
            })
          }
          else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },


    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    successToast (taskName) {
      this.$bvToast.toast(this.$i18n.t('Practice') + ' "' + taskName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    },
  },


}
</script>

<style scoped>
.bg-grey-custom{
  background: #F0F0F0 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}
.text-grey{
  color: var(--main-grey);
}



</style>



// WEBPACK FOOTER //
// src/views/practice/PracticeEdit.vue